.navHeader {
    line-height: 24px;
    padding-left: 24px;
    margin: 0px 0px 8px 0px;
}
